import useCallApiUrl from "hook/useCallApiUrl";
import { formatterCreateAt } from "components/Function";
import { useNavigate } from "react-router-dom";

const Posts = () => {
    const navigate = useNavigate();
    const { data } = useCallApiUrl("/api/posts");
    return (
        <div className="row">
            <div className="col-md-9">
                <div className="mt-4 card card-body">
                    {(data?.data || []).map((post) => {
                        return (
                            <div
                                onClick={() => navigate(`/admin/posts/${post.slug}`)}
                                className="d-flex gap-4 w-full mt-5 al-cursor-pointer"
                                key={post._id}
                            >
                                <div>
                                    <img
                                        alt="post-image"
                                        className="border"
                                        src={
                                            post.image || require("components/assets/media/illustrations/dozzy-1/4.png")
                                        }
                                        style={{ width: "60px", height: "60px", objectFit: "cover" }}
                                    />
                                </div>
                                <div className="p-2" style={{ overflow: "hidden" }}>
                                    <h5
                                        data-tooltip-id="my-tooltip"
                                        data-tooltip-content={post.title}
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {post.title}
                                    </h5>
                                    <p className="mt-0">{formatterCreateAt(post.created_at)()}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Posts;
